import React from "react";
import { motion } from "framer-motion";
import BulletPoint from "./BulletPoint.jsx";

const StartUp = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, delay: 0.1 }}
      className="w-full"
    >
      {/* JOB TITLE & COMPANY */}
      <div className="flex flex-wrap text-white gap-1 font-medium text-xl font-titleFont flex-col sml:flex-row">
        <h3 className="text-white">Data Science Fellow</h3>
        <span className="text-sm mt-1 font-medium text-textGreen flex">
          @ Fellowship.ai
        </span>
      </div>

      {/* Working Dates */}
      <p className="pt-3 text-white">1'st Sep 2024 - 15'th Dec 2024</p>

      {/* INTRODUCTION */}
      {/* <p className="mt-3 text-base font-light flex gap-2 text-textDark">
        <strong>
        </strong>
      </p> */}

      {/* Bullet Points */}
      <ul className="mt-4 flex flex-col gap-3 text-textDark">
        <BulletPoint
          headningText="Causal Inference Analysis"
          contentText="Applied causal inference techniques using Causica and DoWhy to analyze complex datasets and uncover key cause–effect relationships."
        />
        <BulletPoint
          headningText="Treatment-Effect Analysis"
          contentText="Performed treatment-effect analysis to inform product development decisions, improving decision quality by 25%."
        />
        <BulletPoint
          headningText="Causal Model Reliability"
          contentText="Strengthened causal model reliability through refutation testing, reducing runtime by 12% and improving overall application efficiency by 10%."
        />
      </ul>
    </motion.div>
  );
};

export default StartUp;
